import { ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Field } from "@/components/common";
import { digits, maskDoc } from "@/lib/api";
import { ACCOUNT_TYPES, checkBank, maskAccount } from "@/lib/boyCourier";
import { cn } from "@/lib/utils";
import { BankPicker } from "./BankPicker";
import { NextBtn, StepHead } from "./StepBar";

export function StepBank({ f, patch, busy, onSubmit }) {
  const b = f.bank;
  const setB = (p) => patch({ bank: { ...b, ...p } });
  const go = (e) => {
    e.preventDefault();
    const m = checkBank(b);
    if (m) return toast.error(m);
    onSubmit();
  };
  return (
    <form onSubmit={go} className="space-y-4" data-testid="boy-step-bank">
      <StepHead title="Onde você quer receber seus ganhos?" text="A conta bancária precisa obrigatoriamente estar no seu nome e CPF." />
      <div className="flex items-center gap-3 rounded-xl border bg-muted/40 p-3 text-sm" data-testid="boy-bank-holder">
        <ShieldCheck className="h-5 w-5 shrink-0 text-primary" />
        <span className="min-w-0">Titular: <b>{f.name}</b> · CPF {maskDoc(digits(f.cpf))}</span>
      </div>
      <Field label="Banco"><BankPicker value={b} onChange={(x) => setB({ code: x.code, name: x.name })} /></Field>
      <div className="space-y-1.5">
        <p className="text-sm font-medium">Tipo de conta</p>
        <div className="grid grid-cols-2 gap-2" role="radiogroup">
          {Object.entries(ACCOUNT_TYPES).map(([k, l]) => (
            <button key={k} type="button" role="radio" aria-checked={b.type === k} onClick={() => setB({ type: k })} data-testid={`boy-bank-type-${k}`}
              className={cn("h-11 rounded-md border-2 text-sm font-semibold transition-colors", b.type === k ? "border-primary bg-primary/5" : "border-border text-muted-foreground hover:border-primary/40")}>{l.replace("Conta ", "")}</button>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-5 gap-3">
        <Field label="Agência (sem dígito)" className="col-span-2">
          <Input value={b.agency} onChange={(e) => setB({ agency: digits(e.target.value).slice(0, 5) })} inputMode="numeric" placeholder="0000" className="h-12 font-mono" data-testid="boy-bank-agency-input" />
        </Field>
        <Field label="Conta com dígito" className="col-span-3">
          <Input value={b.account} onChange={(e) => setB({ account: maskAccount(e.target.value) })} inputMode="numeric" placeholder="12345-6" className="h-12 font-mono" data-testid="boy-bank-account-input" />
        </Field>
      </div>
      <NextBtn busy={busy} testid="boy-step-bank-submit">Cadastrar Conta</NextBtn>
    </form>
  );
}
